import React, { useState, useEffect } from 'react';
import './pages.css'
import image1 from './images/William.png'
import image2 from './images/William2.png'
import image4 from './images/William6.jpg'
import { tsParticles } from "tsparticles-engine";
import { loadPolygonPath } from "tsparticles-path-polygon";
import { motion } from 'framer-motion';

function About() {

    (async () => {
        await loadPolygonPath(tsParticles);
      
        await tsParticles.load({
          particles: {
            color: {
              value: "#FF0000",
              animation: {
                enable: true,
                speed: 10
              }
            },
            move: {
              attract: {
                enable: false,
                distance: 100,
                rotate: {
                  x: 2000,
                  y: 2000
                }
              },
              direction: "none",
              enable: true,
              outModes: {
                default: "destroy"
              },
              path: {
                clamp: false,
                enable: true,
                delay: {
                  value: 0
                },
                generator: "polygonPathGenerator",
                options: {
                  sides: 6,
                  turnSteps: 30,
                  angle: 30
                }
              },
              random: false,
              speed: 2,
              straight: false,
              trail: {
                fillColor: "#000",
                length: 20,
                enable: true
              }
            },
            number: {
              density: {
                enable: true,
                area: 800
              },
              value: 0
            },
            opacity: {
              value: 1
            },
            shape: {
              type: "circle"
            },
            size: {
              value: 2
            }
          },
          background: {
            color: "#000"
          },
          fullScreen: {
            zIndex: -1
          },
          emitters: {
            direction: "none",
            rate: {
              quantity: 1,
              delay: 1
            },
            size: {
              width: 0,
              height: 0
            },
            position: {
              x: 50,
              y: 50
            }
          }
        });
      })();



    const variants = {
      initial: {
        x: 150,
        opacity: .5,
      },
      animate: {
        x: 0,
        opacity: 1,
      },
      exit: {
        x: -150,
        opacity: .5,
      }
    }
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const images = [
      image1,
      image4,
      image2,
    ];
  
    useEffect(() => {
      const timer = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 15000); // Change the image every 15 seconds
  
      return () => clearInterval(timer);
    }, []);
  
    const handleImageClick = (direction) => {
      if (direction === "prev") {
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
      } else {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }
    };


    return (
            <div className="about-container">
                <body className="about-body">
                  <div className="slideshow-container">
                    <motion.img variants={variants} animate='animate' initial='initial' exit='exit' src={images[currentImageIndex]} alt="Profile pic" className="profile-pic" key={images[currentImageIndex]}/>
                    <button className="slideshow-btn prev" onClick={() => handleImageClick("prev")}>&#10094;</button>
                    <button className="slideshow-btn next" onClick={() => handleImageClick("next")}>&#10095;</button>
                  </div>
                    <p>Hello! I'm William Boyd, a Computer Science Honors senior at the University of Texas at Dallas. In the UTD Honors program, I studied closely with some of the top CS minds in the field. 
                    <br></br><br></br>
                    I'm passionate about AI, machine learning and software development. I have worked on projects including AI image classification, web scraping, app development and website design. Take a look at them on my <u><a href="https://github.com/williamdboyd">github</a></u>.
                    <br></br><br></br>
                    My work experience includes developing software for a blockchain technology startup, designing a web application used as a surveying tool by Toyota Motors, and working in an Amazon warehouse.
                    <br></br><br></br>
                    I was born and raised in Houston, TX and enjoy international travel, recently visiting Tokyo and Okinawa Islands. Some of my hobbies include chess, debate, racquetball, and jogging. Thank you for visiting my website.</p>
                    <h2 className='aboutH2'>Skills</h2>
                    <ul className="skills-list">
                        <li>Go</li>
                        <li>Python</li>
                        <li>C++</li>
                        <li>HTML &amp; CSS</li>
                        <li>Java</li>
                        <li>JavaScript</li>
                        <li>React</li>
                        <li>Pytorch</li>
                        <li>Selenium</li>
                    </ul>
                    <h2 className='aboutH2'>Contact</h2>
                    <p>
                        You can reach me at <u><a href="mailto:wboyd00@gmail.com">wboyd00@gmail.com</a></u> or connect with me on <u><a href="https://www.linkedin.com/in/william--boyd/" target="_blank" rel="noreferrer">LinkedIn</a></u>.
                    </p>
                </body>
            </div>
    );
}

export default About